import React from "react";
import classnames from "classnames";

const Col = ({ children, type = "col", className = "" }) => {
	return <div className={classnames(`${type} ${className}`)}>{children}</div>;
};

export default Col;
